:host {
  display: block;
  font-size: 0.75em;
  span {
    opacity: 0.8;
  }
  a {
    color: var(--av-card-link-color);
  }
}
